import { Injectable } from '@angular/core';
import {
  getGradingResultAwardedMarksFromQuestionItems,
  QuestionAttemptEntityQuery,
  QuestionAttemptEntityService,
} from '@examdojo/question';
import { concatMap, EMPTY, forkJoin, merge } from 'rxjs';
import { StreakService } from '@examdojo/streak';
import { UserMarksService } from '../user/mark/user-marks.service';

@Injectable()
export class UpdateUserMarksOnAttemptGradedService {
  constructor(
    private readonly questionAttemptService: QuestionAttemptEntityService,
    private readonly questionAttemptQuery: QuestionAttemptEntityQuery,
    private readonly userMarksService: UserMarksService,
    private readonly streakService: StreakService,
  ) {
    this.questionAttemptService.attemptGraded$
      .pipe(
        concatMap(({ attemptId }) => {
          const awardedMarks = this.getAwardedMarks(attemptId);

          return merge(
            this.userMarksService.getUserSpentPointsAndLimits(),
            awardedMarks > 0
              ? forkJoin([this.userMarksService.fetchLastWeekUserMarks(), this.streakService.fetchStreaks()])
              : EMPTY,
          );
        }),
      )
      .subscribe();
  }

  private getAwardedMarks(attemptId: string): number {
    const entity = this.questionAttemptQuery.getUIEntity(attemptId);
    return entity ? getGradingResultAwardedMarksFromQuestionItems(entity.questionItems) : 0;
  }
}
